module.exports = __webpack_public_path__ + "static/media/document-file-grey.20d19ea5.svg";